import { render } from "./AttendanceList.vue?vue&type=template&id=1ce433ea&scoped=true"
import script from "./AttendanceList.vue?vue&type=script&lang=js"
export * from "./AttendanceList.vue?vue&type=script&lang=js"

import "./AttendanceList.vue?vue&type=style&index=0&id=1ce433ea&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ce433ea"]])

export default __exports__